$(window).on('load', () => {
  $('.b-slider-container__preloader').css('display', 'none')
  $('.b-info-section__content').css('opacity', '1')
})
